import { render, staticRenderFns } from "./CuentasxPagar.vue?vue&type=template&id=30fd0d20"
import script from "./CuentasxPagar.vue?vue&type=script&lang=js"
export * from "./CuentasxPagar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports